import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  font-family: var(--font-bold);
  font-size: 20px;
  color: var(--text-primary);
  padding: 10px 30px;
  border-bottom: 1px solid var(--line-gray);
  border-top: 1px solid var(--line-gray);
  background: var(--white);
  line-height: normal;

  &:first-child {
    border-top: none;
  }

  &.borderless {
    border: none;
  }
`;

type Props = {
  title: string;
  children?: React.ReactNode;
};

const ShopDataModalContentHeader = ({ title, children }: Props) => {
  return (
    <Container>
      <div>{title}</div>
      <div>{children}</div>
    </Container>
  );
};

export default ShopDataModalContentHeader;
